import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCameraAuto: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="camera-auto"><path d="M2.75 6.75H7.5L9.5 3.75H14.5L16.5 6.75H21.25V20.25H2.75V6.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path fillRule="evenodd" clipRule="evenodd" d="M10.9895 10L7.85156 17H9.62183L10.1089 15.9135H13.8904L14.3774 17H16.1477L13.0098 10H10.9895ZM13.1662 14.2981L11.9996 11.6957L10.833 14.2981H13.1662Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCameraAuto;
